import { z } from 'zod'
import { Pagination } from '../helper'

export const loginHistoryItemSchema = z.object({
  id: z.string(),
  userId: z.string(),
  email: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  ipAddress: z.string().nullish(),
  userAgent: z.string().nullish(),
  loginAt: z.string(),
})

export type TLoginHistoryItem = z.infer<typeof loginHistoryItemSchema>

export type TLoginHistoryList = Pagination<TLoginHistoryItem>
